import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <div className="footer">
      <p>@Copyright 2022, cwmservices</p>
    </div>
  );
}

export default Footer;
